import * as React from "react";
import {
  Text,
  TextInput,
  StyleSheet,
  View,
  Platform,
  TextInputProps,
} from "react-native";
import { useField } from "formik";

import InputIcon, { IInputIconProps } from "./InputIcon";
import StyledButton from "../StyledButton";
import Colors from "../../constants/Colors";
import FontStyles from "../../constants/FontStyle";
import { formatCurrency } from "../../utils/money";

interface IProps extends TextInputProps {
  label?: string;
  fieldName: string;
  preset?: any;
  presetOnly?: any;
  isCurrency?: any;
  editable?: boolean;
  icon?: IInputIconProps;
  numberOfLines?: number;
  placeholder?: string;
}

const FormikInput: React.FC<IProps> = ({
  label,
  fieldName,
  preset,
  presetOnly,
  isCurrency,
  ...props
}) => {
  const [field, meta, helpers] = useField(fieldName);
  const [isFocused, setFocus]: [any, any] = React.useState();

  const handleChange = (val: any) => {
    let text = val.nativeEvent.text;
    if (isCurrency) {
      if (text !== "") {
        text = text.replace(/[^0-9]/g, "");
      }
      if (isNaN(parseFloat(text))) {
        text = "0.00";
      }
      text = (parseFloat(text) / 100).toFixed(2);
      helpers.setValue(formatCurrency(text));
    } else {
      helpers.setValue(text);
    }
  };

  const handleBlur = function (e: any) {
    // console.log(e)
    setFocus(false);
    field.onBlur(fieldName);
  };

  return (
    <>
      {label ? <Text style={styles.inputLabel}>{label}</Text> : null}
      {preset && typeof preset === "object" && preset.length ? (
        <View
          style={{
            flexDirection: "row",
            flexWrap: "wrap",
            paddingTop: 6,
            paddingBottom: 4,
          }}
        >
          {preset.map((x: any, i: any) => (
            <StyledButton
              key={i}
              label={x?.label}
              color="light"
              style={{
                width: undefined,
                paddingHorizontal: 10,
                marginRight: 6,
                marginBottom: 6,
                borderColor:
                  field.value === `${x?.value}`
                    ? Colors.successText
                    : Colors.borderColor,
              }}
              action={() => helpers.setValue(`${x?.value}`)}
            />
          ))}
        </View>
      ) : null}
      {!presetOnly && (
        <View
          style={[
            isFocused ? styles.inputGroupFocus : styles.inputGroup,
            {
              // paddingLeft: props.icon ? 0 : 0,
              opacity:
                props.hasOwnProperty("editable") && props.editable == false
                  ? 0.6
                  : 1,
              // height: props.numberOfLines ? undefined : 40,
              borderColor:
                meta.touched && meta.error
                  ? "#EE0000"
                  : isFocused
                  ? "#3B54EC"
                  : "#EAEAEA",
            },
          ]}
        >
          {props.icon && <InputIcon focused={isFocused} {...props.icon} />}
          <TextInput
            // value={field.value}
            {...field}
            {...props}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={() => setFocus(true)}
            style={[
              styles.inputControl,
              Platform.OS === "web" && { outlineWidth: 0 },
              {
                textAlignVertical: props.numberOfLines ? "top" : "center",
              },
            ]}
          />
        </View>
      )}
      {meta.touched && meta.error ? (
        <Text style={styles.error}>{meta.error}</Text>
      ) : null}
    </>
  );
};

export default FormikInput;

const styles = StyleSheet.create({
  inputLabel: {
    color: Colors.shades._7,
    ...FontStyles.medium,
    ...FontStyles.size14,
    ...FontStyles.lh16,
    marginTop: 21,
  },
  inputGroup: {
    flexDirection: "row",
    borderStyle: "solid",
    borderBottomWidth: 1,
    backgroundColor: Colors.whiteColor,
  },
  inputGroupFocus: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderStyle: "solid",
    backgroundColor: Colors.whiteColor,
  },
  inputControl: {
    flexGrow: 1,
    color: Colors.darkTextColor,
    ...FontStyles.normal,
    ...FontStyles.size15,
    ...FontStyles.lh18,
    paddingVertical: 6,
  },
  error: {
    color: "#ED4067",
    ...FontStyles.normal,
    ...FontStyles.size10,
  },
});
